/* global axios */

import ApiClient from './ApiClient';

class AgentPermissionsAPI extends ApiClient {
    constructor() {
        super('agent_permissions', { accountScoped: true });
    }

    get() {
        return axios.get(`${this.url}`);
    }

    show(accountUserId) {
        return axios.get(`${this.url}/${accountUserId}`);
    }

    update(accountUserId, permissions) {
        return axios.patch(`${this.url}/${accountUserId}`, {
            agent_permission: permissions,
        });
    }

    availablePermissions() {
        return axios.get(`${this.url}/available_permissions`);
    }
}

export default new AgentPermissionsAPI();
